import React, { Component } from 'react';

export class Gridviewcomponent extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center">
                            <img className="card-profile-img" src="../assets/images/sm/avatar1.jpg" alt="" />
                            <h5 className="mb-0">Peter Richards</h5>
                            <span>Computer</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">449 Thompson St, Conway, SC, 29527</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center ribbon">
                            <div className="ribbon-box orange" data-toggle="tooltip" title="Permanent"><i className="fa fa-star"></i></div>
                            <img className="card-profile-img" src="../assets/images/sm/avatar2.jpg" alt="" />
                            <h5 className="mb-0">Ken Smith</h5>
                            <span>Science</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">449 Thompson St, Conway, SC, 29527</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center">
                            <img className="card-profile-img" src="../assets/images/sm/avatar3.jpg" alt="" />
                            <h5 className="mb-0">Alan Johnson</h5>
                            <span>Music</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">5290 NE 50th Rd, Osceola, MO, 64776</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center">
                            <img className="card-profile-img" src="../assets/images/sm/avatar4.jpg" alt="" />
                            <h5 className="mb-0">Alice A Smith</h5>
                            <span>Mathematics</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">462 Acacia Ave, Blythe, CA, 92225</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center ribbon">
                            <div className="ribbon-box orange" data-toggle="tooltip" title="Permanent"><i className="fa fa-star"></i></div>
                            <img className="card-profile-img" src="../assets/images/sm/avatar5.jpg" alt="" />
                            <h5 className="mb-0">Gerald K Smith</h5>
                            <span>Mechanical</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">449 Thompson St, Conway, SC, 29527</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center">
                            <img className="card-profile-img" src="../assets/images/sm/avatar6.jpg" alt="" />
                            <h5 className="mb-0">Peter Richards</h5>
                            <span>Computer</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">449 Thompson St, Conway, SC, 29527</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center">
                            <img className="card-profile-img" src="../assets/images/sm/avatar3.jpg" alt="" />
                            <h5 className="mb-0">Alan Johnson</h5>
                            <span>Music</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">5290 NE 50th Rd, Osceola, MO, 64776</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center ribbon">
                            <div className="ribbon-box green" data-toggle="tooltip" title="HOD"><i className="fa fa-star"></i></div>
                            <img className="card-profile-img" src="../assets/images/sm/avatar2.jpg" alt="" />
                            <h5 className="mb-0">Ken Smith</h5>
                            <span>Science</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">449 Thompson St, Conway, SC, 29527</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center ribbon">
                            <div className="ribbon-box orange" data-toggle="tooltip" title="Permanent"><i className="fa fa-star"></i></div>
                            <img className="card-profile-img" src="../assets/images/sm/avatar5.jpg" alt="" />
                            <h5 className="mb-0">Gerald K Smith</h5>
                            <span>Mechanical</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">449 Thompson St, Conway, SC, 29527</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                        <div className="card-body text-center">
                            <img className="card-profile-img" src="../assets/images/sm/avatar4.jpg" alt="" />
                            <h5 className="mb-0">Alice A Smith</h5>
                            <span>Mathematics</span>
                            <div className="text-muted">+ (916) 369-7180</div>
                            <p className="mb-4 mt-3">462 Acacia Ave, Blythe, CA, 92225</p>
                            <button className="btn btn-primary btn-sm">Read More</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Gridviewcomponent;
